import React, { useState, useEffect, useRef } from "react";
import GainCanvas from './GainCanvas.jsx';

const GainDemo = () => {
    const [audioContext, setAudioContext] = useState(null);
    const [gainNode, setGainNode] = useState(null);
    const [audioBuffer, setAudioBuffer] = useState(null);
    const [sourceNode, setSourceNode] = useState(null);
    const [gain, setGain] = useState(2.0);

    // Create a ref for the canvas
    const canvasRef = useRef(null);

    useEffect(() => {
        const initAudio = async () => {
            const context = new AudioContext();
            await context.audioWorklet.addModule("/audioProcessor.js"); // Load from public folder

            const gainProcessor = new AudioWorkletNode(context, "distortion-processor");
            gainProcessor.parameters.get("gain").value = gain;

            setAudioContext(context);
            setGainNode(gainProcessor);
            drawCanvas();
        };

        initAudio();
    }, []);

    const drawCanvas = () => {
        const canvas = canvasRef.current;
        if (!canvas) {
            console.error("Canvas not found");
            return;
        }
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "red"; // Set fill color
        ctx.fillRect(0, 0, 800, 400); // Draw a red rectangle
    };

    const loadAudio = async () => {
        if (!audioContext) return;
        console.log("Loading audio...");
        const response = await fetch("/audioSample.wav");
        const arrayBuffer = await response.arrayBuffer();
        const decodedBuffer = await audioContext.decodeAudioData(arrayBuffer);
        setAudioBuffer(decodedBuffer);
    };

    const playAudio = () => {
        if (!audioContext || !audioBuffer) return;
        console.log("Playing audio...");
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(gainNode).connect(audioContext.destination);
        source.start();
        setSourceNode(source);
    };

    const stopAudio = () => {
        if (sourceNode) {
            console.log("Stopping audio...");
            sourceNode.stop();
        }
    };

    const handleGainChange = (event) => {
        console.log("Gain change...");
        const newGain = parseFloat(event.target.value);
        setGain(newGain);
        if (gainNode) {
            gainNode.parameters.get("gain").value = newGain;
        }
    };

    return (
        <>
            <div style={{ minHeight: 800 }}>
                <button onClick={loadAudio}>Load Audio</button>
                <button onClick={playAudio}>Play Processed Audio</button>
                <button onClick={stopAudio}>Stop</button>
                <input
                    type="range"
                    min="1"
                    max="10"
                    step="0.1"
                    value={gain}
                    onChange={handleGainChange}
                />


            {/* ✅ Add the canvas and use the ref */}
            <div>
             {/* <canvas ref={canvasRef} width={800} height={400} style={{ background: "#ccc" }} /> */}
            </div>

            {/* GainCanvas component */}
            <div style={{}}>
                <GainCanvas />
            </div>
            </div>
        </>
    );
};

export default GainDemo;
